import React from "react";
import { NavItem, NavLink, Badge, Collapse, DropdownItem } from "shards-react";
import { FaBell } from "react-icons/fa";


export default class Notifications extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };

    this.toggleNotifications = this.toggleNotifications.bind(this);
  }

  toggleNotifications() {
    this.setState({
      visible: !this.state.visible
    });
  }

  render() {
    return (
      <NavItem className="border-right dropdown notifications">
        <NavLink
          className="nav-link-icon text-center"
          onClick={this.toggleNotifications}
        >
          <div className="nav-link-icon__wrapper">
            {/* <i className="material-icons">&#xE7F4;</i> */}
            <FaBell style={{color: 'blue' , fontSize: '20px' }}/> 
            <Badge pill theme="danger">
              2
            </Badge>
          </div>
        </NavLink>
        <Collapse
          open={this.state.visible}
          className="dropdown-menu dropdown-menu-small"
        >
          <DropdownItem>
            <div className="notification__icon-wrapper">
              <div className="notification__icon">
                <i className="material-icons">&#xE6E1;</i>
              </div>
            </div>
            <div className="notification__content">
              <span className="notification__category">Mise à jour</span>
              <p>
                Une nouvelle Mise en servce à vérifier - sur {" "}
                <span className="text-success text-semibold">28%</span> in the
                ce weekend.
              </p>
            </div>
          </DropdownItem>
          <DropdownItem>
            <div className="notification__icon-wrapper">
              <div className="notification__icon">
                <i className="material-icons">&#xE8D1;</i>
              </div>
            </div>
            <div className="notification__content">
              <span className="notification__category">Erreur</span>
              <p>
                Une erreur de suivi constater - Auteur {"Somda Florent "}
                <span className="text-danger text-semibold">405</span>. 
                Ce 15/10/2021
                
              </p>
            </div>
          </DropdownItem>
          <DropdownItem className="notification__all text-center">
          Voir plus
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}
